import { observer } from "mobx-react";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import "./enable-return-guard-onboarding-step.scss";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { IEnableReturnGuardStep } from "../enable-return-guard-shopify-extension/enable-return-guard-shopify-extension";
import { ButtonLink } from "../../../../../components/inputs/button-link/button-link";

interface IProps {
    step: IEnableReturnGuardStep;
}

const EnableReturnGuardOnboardingStep: React.FC<IProps> = observer(({ step }: IProps) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-onboarding";

    return (
        <>
            <div className="enable-return-guard-onboarding-step">
                <img src={step.imgsrc} alt="step number" />
                <FontBody1 color={FONT_COLOR.PRIMARY2}>{step.text}</FontBody1>
            </div>
            {step.shopifyExtensionUrl &&
                <div className="enable-return-guard-onboarding-step-button">
                    <ButtonLink
                        text={getTranslation('OPEN_PAGE', scope)}
                        variant={BUTTON_VARIANTS.Secondary}
                        href={step.shopifyExtensionUrl}
                        target="_blank"
                    />
                </div>
            }
        </>
    )
});

export default EnableReturnGuardOnboardingStep;